import get from "lodash/get";
import map from "lodash/map";
import forEach from "lodash/forEach";
import find from "lodash/find";
import { getStateData } from "analytics/index";
import { constructBranchIOPurchaseEventData } from "./payloadConstructors";
import { ROOT_CHANNEL, WEB, paths } from "utils/constants";
import { BRANCH_STANDARD_EVENT } from "constants/AnalyticsTypeConstants";

export const constructBranchIOEventData = (triggerKey, data, reduxStore) => {
  let eventData = {
    branch_standard_event: "",
    data: {}
  };

  const currentPath = window.location.pathname;

  /**
   * API-related data
   */

  // User-selected Product(s)
  let allUserSelectedAddons =
    getStateData(reduxStore, "api.selectedAddons.data", {}) ?? {}; // includes BOTH user-selected plan AND user-selected addons
  let allUserSelectedAddonsSku =
    map(
      allUserSelectedAddons,
      (selected, addonSku) => {
        if (selected) return addonSku;
      },
      []
    ) ?? [];
  let suggestedAddons =
    getStateData(reduxStore, "api.suggestedAddons.data.productVariants", []) ??
    []; // ADDONS user chooses to supplement their main plan
  let eligiblePlanAllProductVariants =
    getStateData(reduxStore, "api.eligiblePlans.data.productVariants", []) ??
    [];
  let userSelectedPlan =
    find(
      eligiblePlanAllProductVariants,
      [
        "sku",
        `${getStateData(reduxStore, "api.initialSelectedAddon.data", "")}`
      ],
      {}
    ) ?? {}; // plan User selects
  let userSelectedAddons = []; // list of ADDONS (not plan) user has selected
  // Populate userSelectedAddons with ADDONS (not plan), that user has selected
  forEach(
    allUserSelectedAddonsSku,
    userSelectedAddonSku => {
      forEach(suggestedAddons, suggestedAddon => {
        if (
          get(suggestedAddon, "sku", "") === userSelectedAddonSku &&
          get(suggestedAddon, "sku", "") !== get(userSelectedPlan, "sku", "")
        ) {
          userSelectedAddons.push(suggestedAddon);
        }
      });
    },
    []
  );
  // let allUserSelectedItems = [userSelectedPlan, ...userSelectedAddons]; // all user-selected items, plan and addons included

  switch (triggerKey) {
    case "paymentStatus_api_call_succeeded":
      {
        const hasBeenCalled = localStorage.getItem(
          get(BRANCH_STANDARD_EVENT, "PURCHASE")
        );
        if (
          !hasBeenCalled &&
          (currentPath ===
            get(paths, "PAYMENT_SUCCESS", "").replace(ROOT_CHANNEL, WEB) || currentPath === get(paths, "PAYMENT_CARD","").replace(ROOT_CHANNEL, WEB))
        ) {
          eventData = constructBranchIOPurchaseEventData(
            data,
            reduxStore,
            userSelectedPlan
          );
          localStorage.setItem(get(BRANCH_STANDARD_EVENT, "PURCHASE"), true);
        }
      }
      break;
    // case "paymentRequest_api_call_succeeded":
    //   {
    //     const hasBeenCalled = localStorage.getItem(
    //       get(BRANCH_STANDARD_EVENT, "PURCHASE")
    //     );
    //     if (
    //       !hasBeenCalled &&
    //       (currentPath ===
    //         get(paths, "PAYMENT_SUCCESS", "").replace(ROOT_CHANNEL, WEB) || currentPath === get(paths, "PAYMENT_CARD", "").replace(ROOT_CHANNEL, WEB))
    //     ) {
    //       eventData = constructBranchIOPurchaseEventData(
    //         data,
    //         reduxStore,
    //         userSelectedPlan
    //       );
    //       localStorage.setItem(get(BRANCH_STANDARD_EVENT, "PURCHASE"), true);
    //     }
    //   }
    //   break;
    default:
      break;
  }

  return eventData;
};
